function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M32.31,16.71c.24,3.83-.13,7.64-1.47,11.25-.46,1.24-1.07,2.4-1.66,3.57l-1.59,2.55c1.57.21,3.13.57,4.56,1.26.62-.19,1.19-.51,1.83-.68,2.19-.57,4.21-.03,6.39.26-.18-1.79-.4-3.57-.8-5.32-1.14-4.87-3.68-9.42-7.26-12.89Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M52.3,35.51c-2.7-1.68-5.52-1.02-8.47-.58-.26-6.48-2.5-12.68-6.45-17.78-.55-.72-1.22-1.34-1.72-2.1,3.42-.37,6.02-2.79,8.27-5.18.76-.81,1.51-1.7,2.2-2.57l-4.58-1.44-3.27-.66h-2.2c-.58.05-1.54.27-2.12.45-2.08.63-3.88,2.06-5.06,3.85-.46-.15-2.77-1.69-3.08-1.47l-1.24,3.09,3.53,2.12c1.82,6.85.41,14.21-4.1,19.69-.2.12-3.41-1.69-3.97-1.92-7.98-3.31-13.78,5.25-12.98,12.56,1.23,11.21,14.78,16.92,23.8,10.32,1.94,2.11,4.28,3.6,7.06,4.36.84.23,2,.49,2.85.55.85.06,1.76-.05,2.62,0l2.95-.55c9.61-1.91,15.13-17,5.94-22.73ZM16.08,43.4l-3.46.21c-.11-2.44.47-5.09,2.1-6.96.16-.18,1.04-1.13,1.24-.99l1.89,2.77c-1.39,1.25-1.8,3.17-1.78,4.97ZM36.29,46.85l-3.46.21c-.24-2.95.73-6.15,3.19-7.95l1.93,2.86c-1.34,1.24-1.74,3.11-1.66,4.88ZM33.98,34.66c-.64.17-1.2.49-1.83.68-1.43-.69-2.99-1.05-4.56-1.26l1.59-2.55c.59-1.18,1.2-2.34,1.66-3.57,1.33-3.62,1.71-7.42,1.47-11.25,3.57,3.48,6.12,8.03,7.26,12.89.41,1.75.62,3.53.8,5.32-2.17-.29-4.2-.83-6.39-.26Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Game-filled.f24fc76e.svg";
export { SvgComponent as ReactComponent };